import React, { Component } from 'react';
import { reduxForm } from 'redux-form';

import { CREATE_EDIT_USAGE_FORM_NAME } from 'Common/FormEnum';
import PreviewUsageComponent from '../../components/createEditUsage/PreviewUsage';

class PreviewUsageContainer extends Component {
  render() {
    return <PreviewUsageComponent {...this.props} />;
  }
}
export const PreviewUsage = reduxForm({
  form: CREATE_EDIT_USAGE_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(PreviewUsageContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/containers/createEditUsage/PreviewUsage.js